export default __webpack_public_path__ + "static/media/ss1.fdc6c8d6.svg";